<header class="topbar-dashboard">
  <div class="topbar-dashboard__left">
    <div
      class="topbar-dashboard__avatar dropdown d-inline-block user-dropdown"
      ngbDropdown
      *ngIf="role == 'user'"
    >
      <button
        type="button"
        ngbDropdownToggle
        class="btn waves-effect custom-btn"
        id="page-header-user-dropdown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <img src="assets/images/store.png" alt="avatar" />
      </button>
      <div
        class="dropdown-menu dropdown-menu-left justify-content-center p-3 rounded"
        ngbDropdownMenu
      >
        <h5>Danh sách cửa hàng</h5>
        <div
          class="overflow-auto custom-scrollbar"
          style="max-height: 200px;"
        >
          <div
            [ngClass]="{ 'active-workspace': activeWorkspace === data.code }"
            (click)="changeWorkspace(data.code, data.name)"
            *ngFor="let data of listData"
            href="javascript: void(0);"
          >
            <div class="custom-item-topbar d-flex custom-dropdown-item">
              <img
                src="assets/images/store.png"
                class="m-1"
                alt="avatar"
                width="50"
              />
              <div class="p-2">
                <div>{{data.name}} - {{data.code}}</div>
                <div>{{data.leader}}</div>
              </div>
              <i
                *ngIf="data.code == activeWorkspace"
                class="mdi mdi-check-circle text-success ml-auto"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="topbar-dashboard__avatar" *ngIf="role != 'user'">
      <img src="assets/images/store.png" alt="avatar" />
    </div>
    <div class="topbar-dashboard__info">
      <div class="topbar-dashboard__name">{{ workspaceName }}</div>
      <div class="topbar-dashboard__account">{{ workspaceBankAcc }}</div>
      <!-- <div class="topbar-dashboard__owner" *ngIf="workspaceOwner">{{ workspaceOwner }}</div> -->
    </div>
  </div>
  <button class="topbar-dashboard__back-btn" (click)="goBack()">
    <img src="assets/images/btn-back.png" />
  </button>
</header>

<div class="renew-card" *ngIf="device_subscription">
  <div class="renew-card__icon">
    <i class="ri-volume-up-line"></i>
  </div>
  <div class="renew-card__content">
    <p class="renew-card__text">
      Gói dịch vụ của {{ device_subscription?.device_type_name || 'Loa WiFi' }} -
      <strong>{{ device_subscription?.device_subscription_id || '36237' }}</strong>
      {{ device_subscription?.expiry_status == 0 ? 'hết hạn' : 'sắp hết hạn' }},
      hãy gia hạn ngay để tránh gián đoạn dịch vụ
    </p>
    <button
      class="renew-card__btn"
      [routerLink]="'/viettel/service-detail-dashboard/' + device_subscription?.device_subscription_id"
    >
      Gia hạn ngay
    </button>
  </div>
</div>
